import { useMemo } from 'react';

import { formatToCurrency } from 'utils';

export interface JobQuoteItemKandaHook {
  amount: string;
  titleClassName: string;
  amountClassName: string;
  descriptionClassName: string;
}

export default function useJobQuoteItemKanda(
  price: number,
  compact: boolean,
): JobQuoteItemKandaHook {
  const amount = useMemo(() => formatToCurrency(price), [price]);

  const titleClassName = useMemo(
    () =>
      ['text-14-22 text-neutral-900', compact ? '' : 'md:text-16-24 '].join(
        ' ',
      ),
    [compact],
  );

  const amountClassName = useMemo(
    () =>
      [
        'text-14-22 text-neutral-900 text-wrap text-right',
        compact ? '' : 'md:text-16-24',
      ].join(' '),
    [compact],
  );

  const descriptionClassName = useMemo(
    () =>
      [
        'text-12-18 text-neutral-700 -mt-3 col-span-2',
        compact ? '' : 'md:text-14-22',
      ].join(' '),
    [compact],
  );

  return {
    amount,
    titleClassName,
    amountClassName,
    descriptionClassName,
  };
}
